let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9gEN4")).then(() => parcelRequire('kG4oH'));